/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown> }} Sub_Upgrade_Min_SeatsInputs */



/**
* | output |
* | --- |
* | "(min. {min})" |
*
* @param {Sub_Upgrade_Min_SeatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_upgrade_min_seats = /** @type {((inputs: Sub_Upgrade_Min_SeatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Upgrade_Min_SeatsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`(mind. ${i?.min})`)
	return /** @type {LocalizedString} */ (`(min. ${i?.min})`)
});